import { render, staticRenderFns } from "./ModalConfirmDeleteAccount.vue?vue&type=template&id=fefb42d8"
import script from "./ModalConfirmDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmDeleteAccount.vue?vue&type=style&index=0&id=fefb42d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports